import React from "react";

const Divider = ({ height }) => {
    return (
        <section style={{ height }} className="divider_section"></section>
    );
};

export default Divider;